/**
 * @Author: yanglu
 * @Email: 1258947325@qq.com
 * @Blog: https://github.com/ougege/blog
 * @Theme: 进一步封装XLSX，支持自定义导出
 * @Date: 2022/04/27 09:29
 */
// 参考文档: https://github.com/rockboom/SheetJS-docs-zh-CN
import * as XLSX from 'xlsx/xlsx.mjs'
class XLSXFN {
  // 导出数据: headerArr: 表格头(数组); contentJson: 选中内容(数组); fileName： 自定义名称,可选参数
  exportXLSX (headerArr, contentJson, fileName = '导出数据') {
    const wb = XLSX.utils.book_new()
    const { header, json } = this.transToJson(headerArr, contentJson)
    const ws = XLSX.utils.json_to_sheet(json, header)
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
    XLSX.writeFile(wb, `${fileName}.xlsx`)
  }

  // 将传入的表头和数据转成XLSX支持的sheet
  transToJson (headerArr, contentJson) {
    const newArr = []
    for (let i = 0; i < contentJson.length; i++) {
      const tempObj = {}
      for (let j = 0; j < headerArr.length; j++) {
        tempObj[headerArr[j]] = contentJson[i][j]
      }
      newArr.push(tempObj)
    }
    return {
      header: { header: headerArr },
      json: newArr
    }
  }

  // 通过页面的的table，支持固定行导出
  tableToSheet (tableId, lineArr, fileName = '导出数据') {
    // 兼容element的fixed定位，防止重复数据
    const fix = document.querySelector('.el-table__fixed-right') || document.querySelector('.el-table__fixed')
    let wb = null
    if (fix) {
      wb = XLSX.utils.table_to_book(document.getElementById(tableId).removeChild(fix))
      document.getElementById(tableId).appendChild(fix)
    } else {
      wb = XLSX.utils.table_to_book(document.getElementById(tableId))
    }
    const filterArr = ['!rows', '!cols', '!ref', '!fullref']
    const newLineArr = lineArr.join(',').split(',')
    const findArr = []
    // 找出符合行数据
    for (let i = 0; i < newLineArr.length; i++) {
      const tempArr = []
      for (const k in wb.Sheets.Sheet1) {
      // 先过滤特殊标记
        if (!filterArr.includes(k)) {
          const kNum = k.match(/\d*$/)[0]
          if (newLineArr[i] === kNum) {
            tempArr.push(wb.Sheets.Sheet1[k])
          }
        }
      }
      findArr.push(tempArr)
    }
    // 分离出header和content
    const header = []
    const content = []
    for (let k = 0; k < findArr.length; k++) {
      if (k === 0) {
        findArr[k].forEach(li => {
          header.push(li.v)
        })
      } else {
        const tempArr = []
        findArr[k].forEach(li => {
          tempArr.push(li.v)
        })
        content.push(tempArr)
      }
    }
    this.exportXLSX(header, content, fileName)
  }
}
const XLSXFn = new XLSXFN()
export { XLSXFn }
